import "./dashboard.scss";

import { FilterDashboardProvider } from "./filter-dashboard/filter-dashboard.context";
import ListDetails from "./list-details/list-details";

 
export interface DashboardProps {}

export function Dashboard() {
  return (
    <div>
      <FilterDashboardProvider>
        <ListDetails />
      </FilterDashboardProvider>
    </div>
  )
}

export default Dashboard;
